import { Link } from 'react-router-dom';
export default function MobileNav({ open, onClose }) {
  return (
    <div className={`mnav${open ? ' open' : ''}`} id="mnavPanel" onClick={(e) => { if (e.target.id === 'mnavPanel') onClose(); }}>
      <div className="mnav-panel">
        <span className="mgrp">FEATURES</span>
        <Link className="sub" to="/pattern-intelligence">Pattern Intelligence</Link>
        <Link className="sub" to="/monitoring">Workforce Analytics</Link>
        <Link className="sub" to="/crm">CRM</Link>
        <Link className="sub" to="/hrms">HRMS</Link>
        <Link className="sub" to="/email-insights">Email Insights</Link>
        <span className="mgrp">EXPLORE</span>
        <Link to="/solutions">Solutions</Link>
        <Link to="/pricing">Pricing</Link>
        <Link to="/resource-optimizer">Managed Services</Link>
        <Link to="/contact">Contact Us</Link>
        <Link to="/download">Download</Link>
        <Link to="/login">Sign In</Link>
        <Link to="/register" style={{ color: 'var(--teal-deep)' }}>Register — free trial</Link>
        <button className="mnav-close" id="mnavClose" type="button" onClick={onClose}>Close</button>
      </div>
    </div>
  );
}
